/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ui.container[_ngcontent-%COMP%]{margin-top:40px}.notifications-container[_ngcontent-%COMP%]{padding:0}.list[_ngcontent-%COMP%]{margin-top:30px}.list[_ngcontent-%COMP%]   .item[_ngcontent-%COMP%]{padding:15px 20px}.list[_ngcontent-%COMP%]   .item[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]{margin-bottom:8px}.list[_ngcontent-%COMP%]   .item[_ngcontent-%COMP%]   .description[_ngcontent-%COMP%]{white-space:pre-line}.list[_ngcontent-%COMP%]   .item[_ngcontent-%COMP%]:hover{background:#3f3f3f}"];
export { styles as styles };
